import { jarvisPublicApi } from './jarvis-api'

export default class UserApi {
  static loginCheck (username, password) {
    return jarvisPublicApi.post('/login-check', {
      username: username,
      password: password
    })
  }

  static forgotPassword (username) {
    return jarvisPublicApi.post('/password/forgot', {
      username: username
    })
  }

  static checkAuthorizationResetPassword (id, token) {
    return jarvisPublicApi.post('/password/reset/check', {
      id: id,
      token: token
    })
  }

  static resetPassword (id, token, password, isFirstReset) {
    return jarvisPublicApi.post('/password/reset', {
      id: id,
      token: token,
      password: password,
      isFirstReset: isFirstReset
    })
  }
}
